/*
 * Copyright (c) 2024 SARL SIGMA POLYNESIA
 */

import { Badge, BadgeProps } from '@mantine/core'
import { useFormContext } from '@jalik/react-form'
import { useIntl } from 'react-intl'

function FormStateBadge (props: BadgeProps) {
  const intl = useIntl()
  const form = useFormContext()
  return (
    <Badge
      size="sm"
      color={form.modified ? 'orange' : 'lightgray'}
      {...props}
    >
      {form.modified
        ? intl.formatMessage({
          id: 'modified',
          defaultMessage: 'Modifié'
        })
        : intl.formatMessage({
          id: 'not_modified',
          defaultMessage: 'Non modifié'
        })}
    </Badge>
  )
}

export default FormStateBadge
